import { fmt, type ValueKind } from '../insightFormat';
import type { CsvCell } from '../../../core/rules/csv';
export type Column = {
  label: string;
  kind?: ValueKind | 'text';
};
export type TableData = {
  columns: Column[];
  rows: CsvCell[][];
};
type Props = TableData & {
  caption: string;
  className?: string;
};

/** De cijfers achter een grafiek als gewone tabel: om te lezen, voor schermlezers en als CSV. */
export function DataTable({
  columns,
  rows,
  caption,
  className = ''
}: Props) {
  if (rows.length === 0) return <p className={`py-6 text-center text-[13px] text-muted ${className}`} data-id="element-1789" data-mp="10f9oz0c7682e">Niets in deze periode.</p>;
  return (
    // Scrollt horizontaal: met tabIndex ook met het toetsenbord te bereiken (axe `scrollable-region-focusable`).
    <div className={`-mx-4 overflow-x-auto focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay sm:mx-0 ${className}`} tabIndex={0} role="region" aria-label={caption} data-id="element-1790" data-mp="1a4b82ze1h5kl">
      <table className="w-full min-w-max text-[13px]" data-id="element-1791" data-mp="1j3ogdoqffo3q">
        <caption className="sr-only" data-id="element-1792" data-mp="x67vjkp3jzjj">{caption}</caption>
        <thead className="text-[12px] text-muted" data-id="element-1793" data-mp="t3utb69k6jri">
          <tr className="border-b border-line" data-id="element-1794" data-mp="t29vn7ry6kpf">
            {columns.map((c, i) => <th key={c.label} scope="col" className={`py-2 font-normal ${i === 0 ? 'sticky left-0 bg-white pl-4 pr-3 text-left sm:pl-0' : 'px-3 text-right'} ${i === columns.length - 1 ? 'pr-4 sm:pr-0' : ''}`} data-id="element-1795" data-mp="o5jgcmnyvt52" data-mpi={i}>
                {c.label}
              </th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-line" data-id="element-1796" data-mp="173cllvm2cf5m">
          {rows.map((r, ri) => <tr key={ri} data-id="element-1797" data-mp="124j4zubhc818" data-mpi={ri}>
              {r.map((cell, i) => {
              const kind = columns[i]?.kind ?? (i === 0 ? 'text' : 'number');
              const text = kind === 'text' ? cell === null || cell === '' ? '–' : String(cell) : fmt(typeof cell === 'number' ? cell : null, kind);
              return i === 0 ? <th key={i} scope="row" className="sticky left-0 max-w-[16rem] truncate bg-white py-2 pl-4 pr-3 text-left font-normal text-ink sm:pl-0" data-id="element-1798" data-mp="3p0six68ivu4w">
                    {text}
                  </th> : <td key={i} className={`px-3 py-2 text-right tabular-nums text-ink ${i === r.length - 1 ? 'pr-4 sm:pr-0' : ''}`} data-id="element-1799" data-mp="3fapu7i8fp2cd">
                    {text}
                  </td>;
            })}
            </tr>)}
        </tbody>
      </table>
    </div>
  );
}

/** Voor de CSV: bedragen in euro's (centen / 100), de rest zoals hij is. */
export const csvRows = ({
  columns,
  rows
}: TableData): CsvCell[][] => rows.map(r => r.map((cell, i) => columns[i]?.kind === 'money' && typeof cell === 'number' ? cell / 100 : cell));